import { useCallback, useState } from 'react';
import axios from 'axios';

import { RequestInfo } from './types';

const useAxiosRequest = () => {
  const [requestData, setRequestData] = useState<RequestInfo | null>(null);

  const send = useCallback(async (url: string, requestHeaders: Record<string, string>) => {
    const startTime = performance.now();
    setRequestData({
      method: 'POST',
      url: url,
      status: 'pending',
      startTime,
    });

    try {
      const responseStartTime = performance.now();
      const response = await axios.post(url, {}, { headers: requestHeaders });
      const responseEndTime = performance.now();
      const responseTime = responseEndTime - responseStartTime;

      const headers: Record<string, string> = {};
      Object.entries(response.headers).forEach(([key, value]) => {
        if (value && typeof value === 'string') {
          headers[key] = value;
        }
      });

      const responseBody = JSON.stringify(response.data);
      const responseSize = new Blob([responseBody]).size;

      setRequestData({
        method: 'POST',
        url: url,
        status: 'completed',
        statusCode: response.status,
        statusText: response.statusText,
        headers,
        responseTime,
        responseSize,
        responseBody,
        startTime,
      });
    } catch (error) {
      setRequestData({
        method: 'POST',
        url: url,
        status: 'error',
        error: error instanceof Error ? error.message : 'Unknown error',
        startTime,
      });
    }
  }, []);

  return [requestData, send] as const;
};

export default useAxiosRequest;
